/**
 * The Lab settings as analytics and Photo Studio history record them. A described style (`styleClause`) is free text
 * the user wrote, so only its length is kept — at any depth, as a combined run nests the Stage settings.
 */
export const toLabRecordedSettings = (settings: Record<string, unknown>): Record<string, unknown> =>
  Object.fromEntries(Object.entries(settings).map(([key, value]): [string, unknown] => {
    if (key === 'styleClause') return ['styleClauseLength', typeof value === 'string' ? value.trim().length : 0]
    if (value && typeof value === 'object' && !Array.isArray(value)) return [key, toLabRecordedSettings(value as Record<string, unknown>)]
    return [key, value]
  }))
